import { PTI_POSITION_KEYS } from "./ptiConstants";

export type PtiFluidLevel = "BelowMinimum" | "AtMinimum" | "Good" | "AtMaximum";

export const PTI_FLUID_LEVEL_OPTIONS: Array<{ value: PtiFluidLevel; label: string }> = [
    { value: "BelowMinimum", label: "Below min" },
    { value: "AtMinimum", label: "At min" },
    { value: "Good", label: "Good" },
    { value: "AtMaximum", label: "At max" },
];

export const PTI_FLUID_LEVEL_LABELS: Record<PtiFluidLevel, string> = {
    BelowMinimum: "Below minimum",
    AtMinimum: "At minimum",
    Good: "Good",
    AtMaximum: "At maximum",
};

export const FLUID_LEVEL_POSITIONS: Set<string> = new Set([
    PTI_POSITION_KEYS.Coolant,
    PTI_POSITION_KEYS.Oil,
]);

export function isFluidLevelPosition(positionKey: string): boolean {
    return FLUID_LEVEL_POSITIONS.has(positionKey);
}

export function getFluidLevelLabel(level?: PtiFluidLevel | null): string {
    if (!level) {
        return "—";
    }
    return PTI_FLUID_LEVEL_LABELS[level] ?? level;
}

export type FluidLevelZone = "danger" | "caution" | "safe" | "unknown";

export function getFluidLevelZone(level?: PtiFluidLevel | null): FluidLevelZone {
    switch (level) {
        case "BelowMinimum":
            return "danger";
        case "AtMinimum":
        case "AtMaximum":
            return "caution";
        case "Good":
            return "safe";
        default:
            return "unknown";
    }
}

export function getFluidLevelChipColor(
    level?: PtiFluidLevel | null
): "success" | "warning" | "error" | "default" {
    switch (getFluidLevelZone(level)) {
        case "safe":
            return "success";
        case "caution":
            return "warning";
        case "danger":
            return "error";
        default:
            return "default";
    }
}
